import { Typography } from "@material-ui/core"
import mainCss from "../../../../../assets/css/main.module.css";
import useRkCtxBo from "../../../../../consumer/rk/ctx-provider/useRkCtx";
import NumberUtil from "../../../../../app/util/NumberUtil";
import { getTextBeitrag } from "../../../../../consumer/form/dto/StvZahlungsweise";
import useWizardFormCtx from "../../ctx-provider/useWizardFormCtx";
import TransitionFade from "../../../../transition/TransitionFade";
import AppTranslation from "../../../../../app/AppTranslation";
import { exportProduktMitSchutzbrief } from "../../step-angebot/produkt/Produkt";

export const ProduktDevMobile: React.FC = () => {
    const { wizardFormBo } = useWizardFormCtx();
    const rkCtxBo = useRkCtxBo();

    const schutzbrief = exportProduktMitSchutzbrief(wizardFormBo.angebot);
    const titelText = AppTranslation.getProduktTitelAntrag(schutzbrief);

    const produktBeitrag = schutzbrief ? rkCtxBo.paketMitSchutzbrief?.bruttobeitragLautZw : rkCtxBo.paketOhneSchutzbrief?.bruttobeitragLautZw;
    const produktBeitragText = produktBeitrag ? NumberUtil.formatWaehrung(produktBeitrag) : "";

    const zahlungsweiseTextBeitrag = rkCtxBo.zahlungsweise ? getTextBeitrag(rkCtxBo.zahlungsweise) : "";

    return (
        <TransitionFade>
            <div style={{ width: '100%', backgroundColor: 'white' }}>
                <div className={mainCss.productSummaryHeaderMobile} style={{ textAlign: 'center' }}>
                    <Typography color='textSecondary' variant='subtitle2'>{titelText}</Typography>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline' }}>
                        <Typography color='textSecondary' variant='body1' >{produktBeitragText}</Typography>
                        <Typography color='textSecondary' variant='h6' style={{ marginLeft: 10 }}>{zahlungsweiseTextBeitrag}</Typography>
                    </div>
                </div>
            </div>
        </TransitionFade>
    );

}
export default ProduktDevMobile;